import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WebMenuNode } from 'app/com/ibm/tw/commons/beans/web.menu.node';
import { MessageType } from 'app/com/ibm/tw/commons/enums/global/message.type';
import { TxnService } from 'app/services';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';
import { EventData, Item, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { ValidatorService } from 'ui-components/validator';
import { AxthenticationService } from '../../../../services/axthentication.service';
import { WebMenuItem } from './megamenu/webmenuitem';
import { TimeoutPopupViewForm } from './timeoutpopup/timeout.popup.viewfrom';
declare function closeAllPopupPanel(): void;

@Component({
    standalone: false,
    selector: 'main-header',
    templateUrl: './ccmhmanno.home.header.component.html'
})

export class CcmhmannoHomeHeaderComponent implements OnInit, OnDestroy {

    @Output() onClick: EventEmitter<any> = new EventEmitter();

    @Output() onClickHome: EventEmitter<any> = new EventEmitter();

    @Output() onSelectArea: EventEmitter<any> = new EventEmitter();

    @Output() onSelectLanguage: EventEmitter<any> = new EventEmitter();

    /**
     * 點開漢堡選單.
     */
    @Output() doClickMbMenu: EventEmitter<any> = new EventEmitter();

    /** 目前的語系  */
    @Input() currentLangItem: Item;

    /** 使用者可使用區域清單. */
    @Input() userAreaOptions: Item[];

    /** 目前的地區  */
    @Input() currentArea: string;

    /** 使用者可使用的語系. */
    @Input() languageOptions: Item[];

    /** 目前的地區名稱  */
    @Input() areaName: string;

    timerSubscription: Subscription;

    /** 我的最愛清單 */
    favoriteTaskList: WebMenuItem[] = [];

    /** 顯示timeout popup. */
    timeoutDisplay: boolean;

    /** timeout viewform */
    timeoutViewForm: TimeoutPopupViewForm = new TimeoutPopupViewForm();

    /** 重設timeout */
    resetTimeout: boolean = false;

    /** 選單 */
    public menu: WebMenuNode = null;

    /** 瀏覽紀錄 */
    historys: WebMenuItem[] = [];

    /** 是否顯示瀏覽紀錄 */
    showHistory: boolean = false;

    /** 是否顯示我的最愛 */
    showFavourite: boolean = false;

    /** 是否顯示自訂我的最愛 */
    showCustomFavourite: boolean = false;

    /** 是否顯示登出確認Popup */
    displayLogoutConfirm: boolean = false;

    timer: any;

    timerFavourite: any;

    hour: String;

    /** 是否開啟服務總覽popup, */
    displayCcmotview: boolean = false;


    /** 是否有其它區域可以選擇 */
    haveAreaOptions: boolean = false;

    /** 智能客服. */
    linkTitle1: String;

    /** 服務總覽. */
    linkTitle2: String;

    /** 是否開啟地區選單 */
    showLocationOptions: boolean = false;

    /** 是否開啟語言選單 */
    showLangOptions: boolean = false;

    constructor(
        private router: Router,
        private validatorService: ValidatorService,
        private axthenticationService: AxthenticationService,
        private statusService: StatusService,
        private domHandler: DomHandler, public txnService: TxnService) {
    }

    ngOnInit() {
        this.menu = this.axthenticationService.menu;

        this.haveAreaOptions = this.userAreaOptions != null && this.userAreaOptions.length > 1;

        if (environment.isDemo) {
            this.haveAreaOptions = false;
        }

        // console.log(' this.userAreaOptions===========' + this.userAreaOptions, this.userAreaOptions);

        this.linkTitle1 = this.txnService.transform('智能客服', 'chm00002572', null);

        this.linkTitle2 = this.txnService.transform('服務總覽', 'chm00001759', null);

    }

    /**
     * 換區
     */
    doClickUserAreaAction(event: EventData, option: Item) {
        event.preventDefault();
        this.showLocationOptions = false;
        event.value = option.value;

        this.onSelectArea.emit(event);
    }

    timerCallback(eventData: EventData) {
        this.hour = eventData.value;
    }

    /**
     * 開啟登出確認頁
     */
    showLogoutConfirm(event: EventData): void {
        event.preventDefault();
        this.displayLogoutConfirm = true;
    }

    closeLogoutConfirm(event): void {
        if (this.displayLogoutConfirm) {
            this.displayLogoutConfirm = false;
            if (event) {
                // 登出
                this.statusService.show();
                this.axthenticationService.logout();
            }
        }
    }

    /**
     * 點擊漢堡選單.
     */
    clickMbMenu(event: Event) {
        event.preventDefault();
        // console.log('clickMbMenu.......');
        this.doClickMbMenu.emit({});
    }

    /**
     * 解析目前地區的table 名稱.
     * @param areaType
     */
    parseAreaLabel(areaType: string) {
        for (let j = 0; j < this.userAreaOptions.length; j++) {
            let area = this.userAreaOptions[j];
            // console.log('areaType=' + areaType + ',' + area.value + ',' + area.label);
            if (areaType === area.value) {
                return area.label;
            }
        }
    }

    /**
     * 額外處理web menu item.
     * @param webMenuItemArray
     */
    parseWebMenuItemLabel(webMenuItemArray: WebMenuItem[]) {
        let webMenuItemList: WebMenuItem[] = JSON.parse(JSON.stringify(webMenuItemArray));
        if ((webMenuItemList !== undefined) && webMenuItemList !== null) {
            for (let i = 0; i < webMenuItemList.length; i++) {
                let webMenuItem = webMenuItemList[i];
                if (webMenuItem.areaType !== this.axthenticationService.companyAreaType) {
                    // console.log('areaType=' + webMenuItem.areaType + ',company=' + this.axthenticationService.companyAreaType);
                    if (webMenuItem.areaType !== undefined) {
                        webMenuItem.name += '(' + this.parseAreaLabel(webMenuItem.areaType) + ')'
                    }
                }
            }
        }
        return webMenuItemList;
    }

    /**
     * 開啟瀏覽記錄對話框
     */
    openHistory(event) {
        closeAllPopupPanel();
        this.historys = this.parseWebMenuItemLabel(this.axthenticationService.historyList);

        if (this.showHistory) {
            this.showHistory = false;
        } else {
            this.showHistory = true;
            this.showFavourite = false;
        }

    }

    /**
     * 點擊瀏覽記錄
     */
    clickHistory(event: EventData, clickmenu: WebMenuItem): void {
        event.preventDefault();
        // console.log('event...' + JSON.stringify(event));
        // console.log('clickmenu...' + JSON.stringify(clickmenu));

        // console.log('this.currentArea...' + this.currentArea);
        this.axthenticationService.currentArea = clickmenu.areaType
        // this.axthenticationService.currentArea = clickmenu.areaType;
        clickmenu.url = clickmenu.value;
        // this.axthenticationService.addHistory(clickmenu);

        let eventData: EventData = new EventData(event, clickmenu.value, true, null);
        eventData.taskID = clickmenu.taskIxd;
        eventData.value = clickmenu.value;
        eventData.originalEvent = clickmenu;
        this.onClick.emit(eventData);
    }

    /**
     * 開啟我的最愛對話框
     * @param event
     */
    openFavourite(event) {
        closeAllPopupPanel();
        this.favoriteTaskList = this.parseWebMenuItemLabel(this.axthenticationService.favoriteTaskList);
        if ((this.favoriteTaskList !== undefined) && this.favoriteTaskList !== null) {

        }

        if (this.showFavourite) {
            this.showFavourite = false;
        } else {
            this.showFavourite = true;
            this.showHistory = false;
        }

    }

    /**
     * 點擊我的最愛
     */
    clickFavourite(event: EventData, clickmenu: WebMenuItem): void {
        event.preventDefault();

        clickmenu.url = clickmenu.value;
        // console.log('event...' + JSON.stringify(event));
        // console.log('clickmenu...' + JSON.stringify(clickmenu));

        let eventData: EventData = new EventData(event, clickmenu.value, true, null);
        eventData.taskID = clickmenu.taskIxd;
        eventData.value = clickmenu.value;

        eventData.originalEvent = clickmenu;
        this.onClick.emit(eventData);
    }

    /**
     * 開啟自訂我的最愛
     */
    openCustomFavourite(event) {
        this.showHistory = false;
        this.showFavourite = false;
        this.showCustomFavourite = true;
    }

    onCustomFavoriteShow(event: EventData) {
        this.showCustomFavourite = true;
    }

    onFavoriteCallBack(event: EventData) {
        this.statusService.setMessage({
            'severity': 'info',
            'for': MessageType.UPDATE_FAVORITE, 'summary': 'update favorite'
        });
        this.showCustomFavourite = false;
    }

    onMouseEnter(e: Event) {
        clearTimeout(this.timerFavourite);
    }

    // @HostListener('mouseleave', ['$event'])
    onMouseLeave(e: Event) {
        this.timerFavourite = setTimeout(() => {
            this.showHistory = false;
            this.showFavourite = false;
        }, 200);
    }

    startTimeoutTimer(event: EventData): void {
        event.preventDefault();
        this.axthenticationService.resetTimer();
    }

    /**
     * 開啟服務總覽popup
     */
    openCcmotview(event: Event) {
        event.preventDefault();
        // show mask
        this.statusService.show();

        if (!this.displayCcmotview) {
            this.displayCcmotview = true;
        }

        event.preventDefault();
    }

    /**
     * 關閉服務總覽popup.
     */
    closeCcmotviewPopup(event: EventData) {
        if (this.displayCcmotview) {
            this.displayCcmotview = false;
        }
    }


    /**
     * 按下服務總覽選單的callback
     */
    doClickCcmotviewPopup(eventData: EventData) {
        // console.log('doClickCcmotviewPopup: ' + JSON.stringify(eventData), eventData);
        if (this.displayCcmotview) {
            this.displayCcmotview = false;
            this.onClick.emit(eventData);
        }
    }

    gotoWelcomePage() {
        this.onClickHome.emit({});
    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        clearInterval(this.timer);
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }

    changeLang(event: EventData, option: Item) {

        event.value = option.value;
        this.showLangOptions = false;
        this.onSelectLanguage.emit(event);

    }

    /**
     * 開關地區選單
     * @param event 
     */
    public openLocationOptions(event: Event): void {
        event.preventDefault();
        this.showLocationOptions = !this.showLocationOptions;
    }
    /**
     * 打開語言選單
     * @param event 
     */
    public openLangOptions(event: Event): void {
        event.preventDefault();
        this.showLangOptions = !this.showLangOptions;
    }

    /**
     * 讓a tag不會發生click後，跑到頁面上方
     * @param event 
     */
    public preventNavigation(event: Event): void {
        event.preventDefault();
    }

}
